import Auth from "@/services/auth"
import Router from "@/router"
import Account from '@/services/account'

const load = (context) => {
  (new Account()).fetch().then(
    res => context.commit('SET_ACCOUNT', res.data)
  ).catch(
    e => console.error(e)
  )
}

const save = (context, data) => {
  context.commit('SET_STATUS', false);

  (new Account()).save(data).then(
    () => {
      context.commit('UPDATE', data)
      context.commit('SET_STATUS', true)
    }
  ).catch(
    e => console.error(e)
  )
}

const reset = (context, params) => {
  context.commit('SET_STATUS', false);

  (new Account()).save(params, 'reset').then(
    () => context.commit('SET_STATUS', true)
  ).catch(
    (e) => console.error(e)
  )
}

const forgot = (context, params) => {
  context.commit('SET_STATUS', false);

  (new Account()).save(params, 'forgot').then(
    () => context.commit('SET_STATUS', true)
  ).catch(
    e => console.error(e)
  )
}

const activate = (context, token) => {
  (new Account()).fetch({ token: token, path: 'activate' }).then(
    res => context.commit('SET_ACCOUNT', res.data)
  ).catch(
    e => console.error(e)
  )
}

const signIn = (context, credentials) => {
  (new Auth()).attempt(credentials).then(
    res => {
      context.commit('SET_ACCOUNT', res.data)
      Router.push({ name: 'list-bundles' })
    }
  ).catch(
    e => console.error(e)
  )
}

const signOut = (context) => {
  (new Auth()).destroy().then(
    () => {
      context.commit('SET_ACCOUNT', null)
      Router.push(({ name: 'sign-in' }))
    }
  ).catch(
    e => console.error(e)
  )
}

export default {
  load,
  save,
  reset,
  forgot,
  signIn,
  signOut,
  activate
}
